import * as React from 'react'

type AdjustButtonProps = {
  onClick: () => void
  className?: string
}

const AdjustButton: React.FC<AdjustButtonProps> = ({ onClick, className = '' }) => {
  return (
    <button 
      type="button" 
      className={`btn btn-sm btn-outline-primary text-nowrap ${className}`}
      onClick={onClick}
    >
      + Tilføj
    </button>
  )
}

export default AdjustButton 